import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
export function trackRegistrationSuccess() {
  // Analytics must never interrupt registration or the core's subsequent reload.
  try {
    const target = window;
    target.dataLayer = target.dataLayer || [];
    target.dataLayer.push({
      event: 'flarum_registration_success',
      method: 'email'
    });
  } catch {
    // A blocked or broken analytics integration must not break signup.
  }
}
export default function registerSignupTracking() {
  override(app, 'request', function (original, options) {
    const body = options.body;
    const emailSignup = options.method?.toUpperCase() === 'POST' && options.url === app.forum.attribute('baseUrl') + '/register' && typeof body === 'object' && body !== null && 'password' in body && !('token' in body);
    const response = original(options);
    if (!emailSignup) return response;
    // Return the chained promise so the event is queued before SignUpModal reloads.
    return response.then(result => {
      trackRegistrationSuccess();
      return result;
    });
  });
}